export default __webpack_public_path__ + "static/media/1933.ed2dfd1d.png";